// import React, { useContext, useEffect, useRef, useState } from "react";
// import { ConfigContext } from "../../../Context/ConfigContext";
// import Slider from "react-slick";
// import Modal from "react-modal";

// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { axiosGet } from "../../../Apis/axiosMethods";
// import { default_image } from "../../../Imgaes";

// Modal.setAppElement("#root");
// Modal.defaultStyles.overlay.position = "fixed";

// const customStyles = {
//   content: {
//     top: "50%",
//     left: "50%",
//     right: "auto",
//     bottom: "auto",
//     marginRight: "-50%",
//     transform: "translate(-50%, -50%)",
//     backgroundColor: "#f9fafb",
//     borderRadius: "10px",
//     zIndex: 9999999999,
//     padding: "20px",
//     overflow: "hidden",
//     border: "none",
//     position: "absolute",
//   },
//   overlay: {
//     position: "fixed",
//     inset: 0,
//     zIndex: 999999999,
//     backgroundColor: "rgba(0,0,0,0.93)",
//   },
// };

// const OEPartImages = ({ PART_NUMBER, setOEThumb, setSticky = () => { } }) => {
//   const { OEDetailsImagesURL, apiB2BURL, apiHeaderJson } = useContext(ConfigContext);

//   const [medias, setMedias] = useState([]);
//   const [selectedImg, setSelectedImg] = useState(0);
//   const [loadingMedia, setLoadingMedia] = useState(false);
//   const [modalIsOpen, setIsOpen] = useState(false);
//   const [activeSliderIndex, setActiveSliderIndex] = useState(0);

//   const sliderRef = useRef(null);

//   useEffect(() => {
//     if (PART_NUMBER) {
//       GetPartMedias();
//     }
//   }, [PART_NUMBER]);

//   const GetPartMedias = async () => {
//     try {
//       setLoadingMedia(true);
//       setMedias([]);

//       const { data } = await axiosGet(`/Parts/GetOEPartMedias?part_number=${PART_NUMBER}`);

//       let iRows = [];

//       if (data?.success) {
//         for (let i = 0; i < data.data.length; i++) {
//           const row = data.data[i];

//           iRows.push({
//             image: row.MEDIA_SOURCE,
//           });
//         }
//       }

//       setMedias(iRows);

//       if (setOEThumb) {
//         setOEThumb(iRows[0].image || default_image);
//       }
//     } catch (error) {
//       console.error("Error fetching media:", error);
//     } finally {
//       setLoadingMedia(false);
//     }
//   };

//   function openModal() {
//     setSticky(false);
//     setIsOpen(true);

//     setTimeout(() => {
//       sliderRef.current?.slickGoTo(selectedImg);
//     }, 150);
//   }

//   function closeModal() {
//     setSticky(true);
//     setIsOpen(false);
//   }

//   // body lock
//   useEffect(() => {
//     const siteHeader = document.querySelector("header");
//     const navbar = document.querySelector(".navbar");
//     const stickySearch = document.querySelector(".sticky-search");

//     if (modalIsOpen) {
//       const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

//       document.body.style.overflow = "hidden";
//       document.documentElement.style.overflow = "hidden";
//       document.body.style.paddingRight = `${scrollbarWidth}px`;

//       siteHeader && (siteHeader.style.visibility = "hidden");
//       navbar && (navbar.style.visibility = "hidden");
//       stickySearch && (stickySearch.style.visibility = "hidden");
//     } else {
//       document.body.style.overflow = "auto";
//       document.documentElement.style.overflow = "auto";
//       document.body.style.paddingRight = "0px";

//       siteHeader && (siteHeader.style.visibility = "visible");
//       navbar && (navbar.style.visibility = "visible");
//       stickySearch && (stickySearch.style.visibility = "visible");
//     }

//     return () => {
//       document.body.style.overflow = "auto";
//       document.documentElement.style.overflow = "auto";
//       document.body.style.paddingRight = "0px";

//       siteHeader && (siteHeader.style.visibility = "visible");
//       navbar && (navbar.style.visibility = "visible");
//       stickySearch && (stickySearch.style.visibility = "visible");
//     };
//   }, [modalIsOpen]);

//   // keyboard support
//   useEffect(() => {
//     const handleKeyNavigation = (e) => {
//       if (!modalIsOpen || !sliderRef.current) return;

//       if (e.key === "ArrowRight") sliderRef.current.slickNext();
//       if (e.key === "ArrowLeft") sliderRef.current.slickPrev();
//       if (e.key === "Escape") closeModal();
//     };

//     window.addEventListener("keydown", handleKeyNavigation);
//     return () => window.removeEventListener("keydown", handleKeyNavigation);
//   }, [modalIsOpen]);

//   // const handleMediaClick = (index) => {
//   //   setSelectedImg(index);
//   // };

//   const handleMediaClick = (index) => {
//     const selectedMedia = medias[index];

//     if (!selectedMedia) return;

//     const reorderedMedia = [
//       selectedMedia,
//       ...medias.filter((_, i) => i !== index),
//     ];

//     setMedias(reorderedMedia);

//     setSelectedImg(0);
//     setActiveSliderIndex(0);

//     setThumbnail(
//       selectedMedia.MEDIA_SOURCE || default_image
//     );

//     if (modalIsOpen) {
//       sliderRef.current?.slickGoTo(0);
//     }
//   };

//   function SampleNextArrow(props) {
//     const { className, style, onClick } = props;
//     return (
//       <div
//         className={className}
//         style={{
//           ...style,
//           display: "block",
//           background: "#000",
//           borderRadius: "100px",
//           right: "10px",
//         }}
//         onClick={onClick}
//       />
//     );
//   }

//   function SamplePrevArrow(props) {
//     const { className, style, onClick } = props;
//     return (
//       <div
//         className={className}
//         style={{
//           ...style,
//           display: "block",
//           background: "#000",
//           borderRadius: "100px",
//           left: "10px",
//           zIndex: 1000,
//         }}
//         onClick={onClick}
//       />
//     );
//   }

//   const settings = {
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     afterChange: (current) => {
//       setActiveSliderIndex(current);
//       setSelectedImg(current);
//     },
//     nextArrow: <SampleNextArrow />,
//     prevArrow: <SamplePrevArrow />,
//   };

//   const ZoomableImage = ({ src }) => {
//     const [scale, setScale] = useState(1);
//     const [origin, setOrigin] = useState("50% 50%");

//     const handleMouseMove = (e) => {
//       const rect = e.currentTarget.getBoundingClientRect();
//       const offsetX = e.clientX - rect.left;
//       const offsetY = e.clientY - rect.top;

//       const x = (offsetX / rect.width) * 100;
//       const y = (offsetY / rect.height) * 100;

//       setOrigin(`${x}% ${y}%`);
//     };

//     return (
//       <div
//         style={{
//           width: "450px",
//           height: "450px",
//           margin: "auto",
//           overflow: "hidden",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           cursor: "zoom-in",
//         }}
//         onMouseEnter={() => setScale(2)}
//         onMouseMove={handleMouseMove}
//         onMouseLeave={() => setScale(1)}
//       >
//         <img
//           alt={PART_NUMBER}
//           src={src || default_image}
//           style={{
//             width: "auto",
//             height: "100%",
//             transform: `scale(${scale})`,
//             transformOrigin: origin,
//             transition: "transform 0.1s ease",
//           }}
//           onError={(e) => {
//             const img = e.currentTarget;
//             img.onerror = null;
//             img.src = default_image;
//             img.style.height = "180px";
//             img.style.maxWidth = "200px";
//             img.style.marginTop = "60px";
//             img.style.marginBottom = "20px";
//           }}
//         />
//       </div>
//     );
//   };

//   // const PictureFrame = () => {
//   //   if (!medias.length) return null;

//   //   const thumb = medias[selectedImg];

//   //   return (
//   //     <div style={{ minHeight: "300px", textAlign: "center" }} onClick={openModal}>
//   //       <ZoomableImage src={thumb.image} />
//   //     </div>
//   //   );
//   // };

//   const PictureFrame = () => {

//     if (loadingMedia) {
//       return (
//         <div
//           style={{
//             minHeight: "300px",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//           }}
//         >
//           <p>Loading image...</p>
//         </div>
//       );
//     }

//     if (!medias.length) {
//       return (
//         <div
//           style={{
//             minHeight: "300px",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//           }}
//         >
//           <img
//             src={default_image}
//             alt="Default Part"
//             style={{
//               maxWidth: "100%",
//               height: "300px",
//               objectFit: "contain",
//             }}
//           />
//         </div>
//       );
//     }

//     const thumb = medias[selectedImg];

//     return (
//       <div
//         style={{ minHeight: "300px", textAlign: "center" }}
//         onClick={openModal}
//       >
//         <ZoomableImage
//           src={thumb?.image || default_image}
//         />
//       </div>
//     );
//   };

//   const Thumbnails = () => (
//     <div
//       style={{
//         display: "flex",
//         overflowX: "auto",
//         overflowY: "hidden",
//         padding: "10px",
//         width: "500px",
//         scrollbarWidth: "thin",
//       }}
//     >
//       {medias.map((img, index) => (
//         <div
//           key={index}
//           style={{
//             flex: "0 0 auto",
//             marginRight: "10px",
//             cursor: "pointer",
//             width: "100px",
//             height: "100px",
//             border: selectedImg === index ? "2px solid #ff8b40" : "1px solid #CCC",
//             borderRadius: "6px",
//           }}
//           onClick={() => handleMediaClick(index)}
//         >
//           <img
//             alt="thumb"
//             src={img.image || default_image}
//             style={{
//               borderRadius: "6px",
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//             }}
//             onError={(e) => {
//               const img = e.currentTarget;
//               img.onerror = null;
//               img.src = default_image;
//               img.style.height = "180px";
//               img.style.maxWidth = "200px";
//               img.style.marginTop = "60px";
//               img.style.marginBottom = "20px";
//             }}
//           />
//         </div>
//       ))}
//     </div>
//   );

//   return (
//     <div>
//       {loadingMedia && <p>Loading media...</p>}

//       <PictureFrame />
//       <Thumbnails />

//       <Modal
//         isOpen={modalIsOpen}
//         onRequestClose={closeModal}
//         style={customStyles}
//         shouldCloseOnOverlayClick={true}
//         shouldCloseOnEsc={true}
//       >
//         <div className="image-slider-container mt-3" style={{ width: "800px" }}>
//           <div style={{ fontSize: "22px", fontWeight: "600", color: "#000" }}>
//             OE Part Images
//           </div>
//           <div style={{ color: "#59666e", fontSize: "12px", textAlign: "left" }}>
//             Part Number: {PART_NUMBER}
//           </div>

//           <Slider ref={sliderRef} {...settings}>
//             {medias.map((thumb, index) => (
//               <ZoomableImage key={index} src={thumb.image} />
//             ))}
//           </Slider>

//           <br />
//           <span>{medias.length} Images</span>

//           <div
//             style={{
//               display: "flex",
//               overflowX: "auto",
//               padding: "10px",
//               marginTop: "10px",
//               width: "800px",
//             }}
//           >
//             {medias.map((img, index) => (
//               <div
//                 key={index}
//                 style={{
//                   flex: "0 0 auto",
//                   marginRight: "10px",
//                   cursor: "pointer",
//                   width: "120px",
//                   height: "120px",
//                   border: activeSliderIndex === index ? "2px solid #ff8b40" : "1px solid #CCC",
//                   borderRadius: "6px",
//                 }}
//                 onClick={() => {
//                   setActiveSliderIndex(index);
//                   sliderRef.current?.slickGoTo(index);
//                 }}
//               >
//                 <img
//                   alt="thumb"
//                   src={img.image || default_image}
//                   width={120}
//                   height={120}
//                   style={{ borderRadius: "6px", objectFit: "cover" }}
//                   onError={(e) => {
//                     const img = e.currentTarget;
//                     img.onerror = null;
//                     img.src = default_image;
//                     img.style.height = "180px";
//                     img.style.maxWidth = "200px";
//                     img.style.marginTop = "60px";
//                     img.style.marginBottom = "20px";
//                   }}
//                 />
//               </div>
//             ))}
//           </div>
//         </div>

//         <span
//           style={{
//             top: "50px",
//             right: "15px",
//             position: "absolute",
//             cursor: "pointer",
//             fontSize: "20px",
//           }}
//           onClick={closeModal}
//         >
//           <i className="fa fa-times"></i>
//         </span>
//       </Modal>
//     </div>
//   );
// };

// export default OEPartImages;

import React, { useContext, useEffect, useRef, useState } from "react";
import { ConfigContext } from "../../../Context/ConfigContext";
import Slider from "react-slick";
import Modal from "react-modal";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { axiosGet } from "../../../Apis/axiosMethods";
import { default_image } from "../../../Imgaes";

Modal.setAppElement("#root");
Modal.defaultStyles.overlay.position = "fixed";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#f9fafb",
    borderRadius: "10px",
    zIndex: 9999999999,
    padding: "20px",
    overflow: "hidden",
    border: "none",
    position: "absolute",
  },
  overlay: {
    position: "fixed",
    inset: 0,
    zIndex: 999999999,
    backgroundColor: "rgba(0,0,0,0.93)",
  },
};

const OEPartImages = ({
  PART_NUMBER,
  setOEThumb,
  setSticky = () => { },
}) => {
  const { OEDetailsImagesURL } = useContext(ConfigContext);

  const [medias, setMedias] = useState([]);
  const [selectedImg, setSelectedImg] = useState(0);
  const [activeSliderIndex, setActiveSliderIndex] = useState(0);
  const [loadingMedia, setLoadingMedia] = useState(false);
  const [modalIsOpen, setIsOpen] = useState(false);

  const sliderRef = useRef(null);

  // -------------------- Get OE Part Medias -------------------- //
  useEffect(() => {
    if (PART_NUMBER) {
      GetPartMedias();
    } else {
      setMedias([]);
      setSelectedImg(0);
      setActiveSliderIndex(0);
      setOEThumb?.(default_image);
    }
  }, [PART_NUMBER]);

  const GetPartMedias = async () => {
    try {
      setLoadingMedia(true);
      setMedias([]);
      setSelectedImg(0);
      setActiveSliderIndex(0);

      const { data } = await axiosGet(
        `/Parts/GetOEPartMedias?part_number=${PART_NUMBER}`
      );

      const iRows = data?.success
        ? (data.data || [])
          .filter((row) => row?.MEDIA_SOURCE)
          .map((row) => ({
            image: row.MEDIA_SOURCE,
          }))
        : [];

      setMedias(iRows);
      setSelectedImg(0);
      setActiveSliderIndex(0);

      setOEThumb?.(iRows[0]?.image || default_image);
    } catch (error) {
      console.error("Error fetching OE part media:", error);
      setMedias([]);
      setOEThumb?.(default_image);
    } finally {
      setLoadingMedia(false);
    }
  };

  // -------------------- Thumbnail Selection -------------------- //
  const handleMediaClick = (index) => {
    const selectedMedia = medias[index];

    if (!selectedMedia) return;

    // Selected thumbnail ko first position par move karo
    const reorderedMedia = [
      selectedMedia,
      ...medias.filter((_, i) => i !== index),
    ];

    setMedias(reorderedMedia);

    // First image ko main image set karo
    setSelectedImg(0);
    setActiveSliderIndex(0);

    // Parent component ki thumbnail update karo
    setOEThumb?.(selectedMedia.image || default_image);

    // Modal slider bhi first image par reset karo
    if (modalIsOpen) {
      sliderRef.current?.slickGoTo(0);
    }
  };

  // -------------------- Open Modal -------------------- //
  const openModal = () => {
    setSticky(false);
    setIsOpen(true);

    setTimeout(() => {
      sliderRef.current?.slickGoTo(selectedImg);
    }, 150);
  };

  // -------------------- Close Modal -------------------- //
  const closeModal = () => {
    setSticky(true);
    setIsOpen(false);
  };

  // -------------------- Body Scroll Lock -------------------- //
  useEffect(() => {
    const siteHeader = document.querySelector("header");
    const navbar = document.querySelector(".navbar");
    const stickySearch = document.querySelector(".sticky-search");

    const elements = [siteHeader, navbar, stickySearch].filter(Boolean);

    if (modalIsOpen) {
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;

      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.style.paddingRight = `${scrollbarWidth}px`;

      elements.forEach((element) => {
        element.style.visibility = "hidden";
      });
    } else {
      document.body.style.overflow = "auto";
      document.documentElement.style.overflow = "auto";
      document.body.style.paddingRight = "0px";

      elements.forEach((element) => {
        element.style.visibility = "visible";
      });
    }

    return () => {
      document.body.style.overflow = "auto";
      document.documentElement.style.overflow = "auto";
      document.body.style.paddingRight = "0px";

      elements.forEach((element) => {
        element.style.visibility = "visible";
      });
    };
  }, [modalIsOpen]);

  // -------------------- Keyboard Navigation -------------------- //
  useEffect(() => {
    const handleKeyNavigation = (event) => {
      if (!modalIsOpen || !sliderRef.current) return;

      if (event.key === "ArrowRight") {
        sliderRef.current.slickNext();
      }

      if (event.key === "ArrowLeft") {
        sliderRef.current.slickPrev();
      }

      if (event.key === "Escape") {
        closeModal();
      }
    };

    window.addEventListener("keydown", handleKeyNavigation);

    return () => {
      window.removeEventListener("keydown", handleKeyNavigation);
    };
  }, [modalIsOpen]);

  // -------------------- Slider Arrows -------------------- //
  const SampleNextArrow = ({ className, style, onClick }) => (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "#000",
        borderRadius: "100px",
        right: "10px",
      }}
      onClick={onClick}
    />
  );

  const SamplePrevArrow = ({ className, style, onClick }) => (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "#000",
        borderRadius: "100px",
        left: "10px",
        zIndex: 1000,
      }}
      onClick={onClick}
    />
  );

  // -------------------- Slider Settings -------------------- //
  const settings = {
    dots: false,
    infinite: medias.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,

    afterChange: (current) => {
      setActiveSliderIndex(current);
      setSelectedImg(current);
      setOEThumb?.(medias[current]?.image || default_image);
    },

    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  // -------------------- Zoomable Image -------------------- //
  const ZoomableImage = ({ src }) => {
    const [scale, setScale] = useState(1);
    const [origin, setOrigin] = useState("50% 50%");

    const handleMouseMove = (event) => {
      const rect = event.currentTarget.getBoundingClientRect();

      const offsetX = event.clientX - rect.left;
      const offsetY = event.clientY - rect.top;

      const x = (offsetX / rect.width) * 100;
      const y = (offsetY / rect.height) * 100;

      setOrigin(`${x}% ${y}%`);
    };

    return (
      <div
        style={{
          width: "450px",
          height: "450px",
          margin: "auto",
          overflow: "hidden",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "zoom-in",
        }}
        onMouseEnter={() => setScale(2)}
        onMouseMove={handleMouseMove}
        onMouseLeave={() => setScale(1)}
      >
        <img
          alt={PART_NUMBER || "OE Part"}
          src={src || default_image}
          style={{
            width: "auto",
            height: "100%",
            objectFit: "contain",
            transform: `scale(${scale})`,
            transformOrigin: origin,
            transition: "transform 0.1s ease",
          }}
          onError={(event) => {
            const img = event.currentTarget;

            img.onerror = null;
            img.src = default_image;

            img.style.height = "180px";
            img.style.maxWidth = "200px";
            img.style.marginTop = "60px";
            img.style.marginBottom = "20px";
          }}
        />
      </div>
    );
  };

  // -------------------- Main Picture Frame -------------------- //
  const PictureFrame = () => {
    if (loadingMedia) {
      return (
        <div
          style={{
            minHeight: "300px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p>Loading image...</p>
        </div>
      );
    }

    if (!medias.length) {
      return (
        <div
          style={{
            minHeight: "300px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={default_image}
            alt="Default OE Part"
            style={{
              maxWidth: "100%",
              height: "300px",
              objectFit: "contain",
            }}
          />
        </div>
      );
    }

    const selectedMedia = medias[selectedImg] || medias[0];

    return (
      <div
        style={{
          minHeight: "300px",
          textAlign: "center",
          cursor: "pointer",
        }}
        onClick={openModal}
      >
        <ZoomableImage src={selectedMedia?.image || default_image} />
      </div>
    );
  };

  // -------------------- Main Thumbnails -------------------- //
  const Thumbnails = () => (
    <div
      style={{
        display: "flex",
        overflowX: "auto",
        overflowY: "hidden",
        padding: "10px",
        width: "500px",
        scrollbarWidth: "thin",
      }}
    >
      {medias.map((img, index) => (
        <div
          key={`${img.image}-${index}`}
          style={{
            flex: "0 0 auto",
            marginRight: "10px",
            cursor: "pointer",
            width: "100px",
            height: "100px",
            border:
              selectedImg === index
                ? "2px solid #ff8b40"
                : "1px solid #ccc",
            borderRadius: "6px",
          }}
          onClick={() => handleMediaClick(index)}
        >
          <img
            alt={`OE Part thumbnail ${index + 1}`}
            src={img.image || default_image}
            style={{
              borderRadius: "6px",
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
            onError={(event) => {
              const imgElement = event.currentTarget;

              imgElement.onerror = null;
              imgElement.src = default_image;
            }}
          />
        </div>
      ))}
    </div>
  );

  // -------------------- Modal Thumbnails -------------------- //
  const ModalThumbnails = () => (
    <div
      style={{
        display: "flex",
        overflowX: "auto",
        padding: "10px",
        marginTop: "10px",
        width: "800px",
      }}
    >
      {medias.map((img, index) => (
        <div
          key={`${img.image}-${index}`}
          style={{
            flex: "0 0 auto",
            marginRight: "10px",
            cursor: "pointer",
            width: "120px",
            height: "120px",
            border:
              activeSliderIndex === index
                ? "2px solid #ff8b40"
                : "1px solid #ccc",
            borderRadius: "6px",
          }}
          onClick={() => handleMediaClick(index)}
        >
          <img
            alt={`OE Part modal thumbnail ${index + 1}`}
            src={img.image || default_image}
            width={120}
            height={120}
            style={{
              borderRadius: "6px",
              objectFit: "cover",
            }}
            onError={(event) => {
              const imgElement = event.currentTarget;

              imgElement.onerror = null;
              imgElement.src = default_image;
            }}
          />
        </div>
      ))}
    </div>
  );

  // -------------------- Render -------------------- //
  return (
    <div>
      <PictureFrame />

      <Thumbnails />

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        shouldCloseOnOverlayClick
        shouldCloseOnEsc
      >
        <div
          className="image-slider-container mt-3"
          style={{ width: "800px" }}
        >
          <div
            style={{
              fontSize: "22px",
              fontWeight: "600",
              color: "#000",
            }}
          >
            OE Part Images
          </div>

          <div
            style={{
              color: "#59666e",
              fontSize: "12px",
              textAlign: "left",
            }}
          >
            Part Number: {PART_NUMBER}
          </div>

          <Slider ref={sliderRef} {...settings}>
            {medias.map((thumb, index) => (
              <ZoomableImage
                key={`${thumb.image}-${index}`}
                src={thumb.image}
              />
            ))}
          </Slider>

          <br />

          <span>{medias.length} Images</span>

          <ModalThumbnails />
        </div>

        <span
          style={{
            top: "50px",
            right: "15px",
            position: "absolute",
            cursor: "pointer",
            fontSize: "20px",
          }}
          onClick={closeModal}
        >
          <i className="fa fa-times" />
        </span>
      </Modal>
    </div>
  );
};

export default OEPartImages;